import axios from 'axios';

export async function notify(data: any): Promise<void> {
    await axios.put(`/api/common/util/notifier/notify`, { namespace: 'r4e-ui2', type: 'error', data });
}
